<div class="level"
  [class]="levelClass">
  <portal-draggable-card [payload]="payload"
    [hasErrors]="(plannable?.hoursToPlan ?? 0) < 0"
    class="card-container">
    <div description
      class="card-description">
      <p data-cy="plannable-title"
        class="info portal-bold"
        portalInputOverflowTooltip
        [matTooltip]="cardTitle"
      matTooltipPosition="above">{{ cardTitle }}</p>
      @if (!isCardSubtitleDepartment) {
        <p class="info"
          portalInputOverflowTooltip
          [matTooltip]="cardSubtitle"
          matTooltipPosition="above">
          {{ cardSubtitle }}
        </p>
      } @else {
        <p class="info"
          translate="common.departmentLabel"
          [translateParams]="{ departmentDescription: cardSubtitle}">
        </p>
      }
    </div>
    <div right
      class="card-plan-capacity"
      [matTooltip]="(cardTooltip | async) ?? ''"
      matTooltipClass="mat-tooltip-multiline"
      matTooltipPosition="below">
      <p class="capacity-number portal-bold">{{ plannable?.hoursToPlan | formatNumber}}</p>
      <fa-icon class="capacity-icon"
      [icon]="['far', 'clock']" />
    </div>
  </portal-draggable-card>
</div>